import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function AiAddonsListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
